import {
  CLEAR_SELECTED_TRANSACTION,
  RESET_TRANSACTIONS,
  RESET_TRANSACTIONS_LOADED_TIMESTAMP,
  RESET_TRANSACTIONS_UPDATED_TIMESTAMP,
  SELECT_TRANSACTION,
  SET_ACCOUNTING_TRANSACTIONS_COUNT,
  SET_TRANSACTIONS_LOADING,
  TransactionsActions
} from '@Actions/transactionsActions';

import { ISearchAccountingSyncExpensesResponse } from '@ClientApi/transactionsApi';
import { IExpenseCombinedModel } from '@Shared/helpers/dataMappers/expenseMappers';

interface ITransactionsState {
  selectedTransaction: IExpenseCombinedModel | null;
  transactionsLoading: boolean;
  lastTransactionsLoadedTimestamp: Date;
  lastTransactionsUpdatedTimestamp: Date;
  accountingCounts: ISearchAccountingSyncExpensesResponse;
}

export const defaultState: ITransactionsState = {
  selectedTransaction: null,
  transactionsLoading: false,
  lastTransactionsLoadedTimestamp: new Date(),
  lastTransactionsUpdatedTimestamp: new Date(),
  accountingCounts: { count: 0, rows: [], amountSum: 0 }
};

export function transactionsReducer(state = defaultState, action: TransactionsActions): ITransactionsState {
  switch (action.type) {
    case SET_TRANSACTIONS_LOADING:
      return {
        ...state,
        transactionsLoading: action.payload
      };
    case RESET_TRANSACTIONS_LOADED_TIMESTAMP: {
      return {
        ...state,
        lastTransactionsLoadedTimestamp: new Date()
      };
    }
    case RESET_TRANSACTIONS_UPDATED_TIMESTAMP: {
      return {
        ...state,
        lastTransactionsUpdatedTimestamp: new Date()
      };
    }
    case RESET_TRANSACTIONS: {
      return {
        ...defaultState,
        lastTransactionsLoadedTimestamp: state.lastTransactionsLoadedTimestamp,
        lastTransactionsUpdatedTimestamp: state.lastTransactionsUpdatedTimestamp
      };
    }
    case SELECT_TRANSACTION: {
      return { ...state, selectedTransaction: action.payload };
    }
    case CLEAR_SELECTED_TRANSACTION: {
      return { ...state, selectedTransaction: null };
    }
    case SET_ACCOUNTING_TRANSACTIONS_COUNT: {
      return { ...state, accountingCounts: action.payload };
    }
    default:
      return state;
  }
}
